import { MatDialogConfig } from "@angular/material/dialog";
import { createRequestAction } from "./action-creators";

export interface OpenDialogPayload {
    componentOrTemplateRef;
    config: MatDialogConfig;
}

export interface CloseDialogPayload {
    dialogId: string;
    responseData?: any;
}

const actionCategory = "Dialog";

export const openDialog = createRequestAction<OpenDialogPayload>(actionCategory, "open");
export const closeDialog = createRequestAction<CloseDialogPayload>(actionCategory, "close");
